<template>
	<div class="pingzheng">
        <main>

            <el-select v-model="address" placeholder="请选择猪场" style="width:204px">
                <el-option
                    v-for="(item,i) in options"
                    :key="i"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>

            <span>提交人： </span>
            <el-input v-model="name" placeholder="提交人" style="display:inline-block" clearable></el-input>

            <span>起止日期： </span>
            <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
            </el-date-picker>

            <el-button style="margin-left:20px" type="success" icon="el-icon-search" @click="search()">搜索</el-button>
            <el-button type="info" icon="el-icon-download" @click="daochu()">导出</el-button>

        </main>
        
        <el-card style="border: solid #ccc 1px">
            <el-table
                :data="tableData"
                stripe
                border
                height="60vh"
                style="width: 200%">

                <el-table-column
                    prop="create_time"
                    label="提交时间">
                </el-table-column>

                <el-table-column
                    prop="tell"
                    label="电话">
                </el-table-column>

                <el-table-column
                    prop="name"
                    label="提交人">
                </el-table-column>

                <el-table-column
                    prop="zhuchang"
                    label="猪场">
                </el-table-column>

                <el-table-column
                    prop="gongsi"
                    label="公司">
                </el-table-column>

                <el-table-column
                    prop="time"
                    label="死亡时间">
                </el-table-column>

                <el-table-column
                    prop="toushu"
                    label="死亡头数">
                </el-table-column>

                <el-table-column
                    prop="zhongliang"
                    label="死亡重量">
                </el-table-column>

                <el-table-column
                    prop="yuanyin"
                    label="死亡原因">
                </el-table-column>

                <el-table-column
                    prop="baoxian"
                    label="申报保险">
                </el-table-column>

                <el-table-column
                    prop="beizhu"
                    label="备注">
                </el-table-column>

                <el-table-column
                    width="550"
                    label="照片">
                    <template slot-scope="scope">
                        <span v-for="(item,i) in (scope.row.url).split(',')">
                            <el-popover
                                placement="bottom"
                                trigger="click">
                                <img :src="item" alt="" style="width:500px;height:500px">
                                <img :src="item" alt="" style="width:100px;height:100px;margin-right:20px" slot="reference" >
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status==0">待审核</p>
                        <p style="color:#67C23A" v-if="scope.row.status==1">审核通过</p>
                        <p style="color:#F56C6C" v-if="scope.row.status==2">审核拒绝</p>
                    </template>
                </el-table-column>

                <el-table-column label="审核" width="160">
                    <template slot-scope="scope" >
                        <div v-if="scope.row.status!=1">
                            <el-button type="text" @click="caoZuoYouKa(scope.row,1)">通过</el-button>
                            <el-button type="text" style="color:#F56C6C" @click="caoZuoYouKa(scope.row,2)">拒绝</el-button>
                            <el-button type="text" style="color:#909399" @click="caoZuoYouKa(scope.row,3)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="shenpiren"
                    label="审核人">
                </el-table-column>

            </el-table>

            <el-pagination
                style="margin:20px 0"
                background
                @current-change="handleCurrentChange"
                :current-page="current_page"
                :page-size="per_page"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>

        </el-card>        

    </div>
</template>

<script>
    import options from "../config/option.js"

    import { powerList,url2 } from '../router/api';
	export default{
		data(){
			return{
                total: 1,
                per_page: 50,
                current_page: 1,
                tableData: [],
                
                name:'',
                time:[],
                options:[],
                address:'',
                
            }
        },
        async mounted() {
            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            var time1 = Y + M + '01'
            var time2 = Y + M +D
            this.time.push(time1)
            this.time.push(time2)

            await this.getUser()
            await this.getList()
        },
		methods: {
            async getUser() {
                await powerList({
                    id:'',
                    name:'',
                    tell: localStorage.getItem('ws_tell'),
                }).then(res => {
                    var list  = res.data[0].org.split(',')
                    list.map(item=> {
                        this.options.push(item)
                    })
                    this.address = this.options[0]
                    if(this.address == '全部') {
                        this.options = options.zhuchang
                    }
                }).catch(err => {
                    console.log(err);
                });
            },

            search() {
                this.current_page = 1
                this.getList()
            },

            handleCurrentChange(val) {
                this.current_page = val;
                this.getList();
            },
            
            async getList() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
               
                await this.axios.get(url2+'sizhuSearch', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        name:this.name,
                        address:this.address =='全部'? '':this.address,
                        time1:time1,
                        time2:time2,
                    }
                }).then(res=> {
                    this.tableData = res.data.data.data
                    this.total = res.data.data.total
                    loading.close();
                }).catch(err=> {
                    console.log(err);
                    loading.close();
                });
            },
            
            daochu() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
                this.axios.get(url2 +'sizhuSearch', {
                    params:{
                        export:1,
                        page:this.current_page,
                        per_page:this.per_page,
                        name:this.name,
                        address:this.address =='全部'? '':this.address,
                        time1:time1,
                        time2:time2,
                    },
                    responseType: 'blob',
                    
                }).then(res=> {
                    const data = res.data 
                    if (Object.prototype.toString.call(data) === '[object Blob]' && data.type.includes('application/vnd.ms-excel')) { 
                        const blob = res.data
                        const a = document.createElement('a')
                        let binaryData = [];
                        binaryData.push(blob);
                        const url= window.URL.createObjectURL(new Blob(binaryData));
                        a.href = url
                        a.download = '下载.csv'
                        a.click()
                        window.URL.revokeObjectURL(url)
                    }else{
                        this.$message.error('下载失败')
                    }
                    loading.close();
                }).catch(err=> {
                    loading.close();
                    console.log(err);
                });
            },

            caoZuoYouKa(x,y) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url2+'caozuoSizhu', {
                        params:{
                            id:x.id,
                            id_status:y,
                            shenpiren:localStorage.getItem('ws_name'),
                        }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.getList()
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type:'error'
                            });
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {});
            }
        }

    }
</script>

<style scoped="scoped" lang='less'>
    .pingzheng {
        padding-left: 10px;
        span {
            font-size: 12px;
        }
    }
    .pingzheng .el-input {
        width:140px;
        margin-right: 20px;
    }
 
    .pingzheng .el-select {
        width:140px;
        margin-right: 20px;
    }
    .pingzheng main {
        margin-bottom: 20px;
    }
    .pingzheng .el-pagination {
        white-space: nowrap;
        padding: 2px 5px;
        color: #303133;
        float: right;
        font-weight: 700;
    }
</style>
